import { useQuery } from "@tanstack/react-query"
import { ColumnsType } from "antd/es/table"
import { EProgram, getProgramList } from "../../../../../service/program"
import { Link } from "react-router-dom"
import dayjs from "dayjs"
import UpdateProgramDisplayIdxModal from "../modal"

interface IProgramDisplayIdx {
    id: number;
    isDisplay: boolean;
    displayIdx: number;
    title: string;
    bookingPeriod: [string, string];
    programPeriod: [string, string];
}

const programDisplayIdxColumns: ColumnsType<IProgramDisplayIdx> = [
    {
        title: '노출순서',
        dataIndex: 'displayIdx',
        render: (q, record) => <UpdateProgramDisplayIdxModal programId={record.id} defaultDisplayIdx={q} />
    },
    {
        title: '프로그램명',
        dataIndex: 'title',
        render: (q, record) => <Link to={`/wellness-program/program/${record.id}`}>{q}</Link>
    },
    {
        title: '운영 기간',
        dataIndex: 'programPeriod',
        render: q => <div>{`${dayjs(q[0]).format('YYYY.MM.DD')} ~ ${dayjs(q[1]).format('YYYY.MM.DD')}`}</div>
    },
    {
        title: '예약 가능기안',
        dataIndex: 'bookingPeriod',
        render: q => <div>{`${dayjs(q[0]).format('YYYY.MM.DD')} ~ ${dayjs(q[1]).format('YYYY.MM.DD')}`}</div>
    },
    {
        title: '상태',
        dataIndex: 'programPeriod',
        render: (q, record) => checkBookingAvailableStatus(q, record.bookingPeriod)
    },
]

const checkBookingAvailableStatus = (programPeriod: [string, string], bookingPeriod: [string, string]) => {
    const [startProgram, endProgram] = programPeriod.map(q => dayjs(q))
    const [startBooking, endBooking] = bookingPeriod.map(q => dayjs(q))

    if (dayjs().isAfter(endProgram)) {
        return '프로그램 종료';
    } else if (dayjs().isBefore(startBooking)) {
        return '오픈예정';
    } else if (dayjs().isAfter(startBooking) && dayjs().isBefore(endBooking)) {
        return '예약가능';
    } else if (dayjs().isAfter(endBooking)) {
        return '예약마감';
    } else {
        return '-';
    }
}

const defaultFieldListMap: IProgramField = {
    program: [EProgram.id, EProgram.isDisplay, EProgram.displayIdx, EProgram.title, EProgram.bookingPeriod, EProgram.programPeriod],
}

const useGetProgramListForDisplayIdx = <T,>(fieldListMap: IProgramField = defaultFieldListMap) => {
    const query = useQuery({
        queryKey: ['getProgramList', fieldListMap],
        queryFn: () => getProgramList<T>(fieldListMap),
        select: res => res.data.data.getProgramList
    })
    return query;
}


export { programDisplayIdxColumns, useGetProgramListForDisplayIdx }